<template>
  <div>
    <div>
      <div class="columns">
        <div class="column is-2"><h1 class="title">Tareas</h1></div>
        <div class="column">
          <button class="button is-link" @click="showformProyect">
            Crear Tarea
          </button>
        </div>
      </div>

      <div>
        <section class="box">
          <div class="columns">
            <div class="column is-1"><h1 class="title is-6">Tags</h1></div>
            <div class="column">
              <div class="buttons">
                <button
                  v-for="(item, index) in tags"
                  :key="index"
                  class="button is-small"
                  :class="classTag(item)"
                  @click="clicktag(item)"
                >
                  {{ item }}
                </button>
              </div>
            </div>
          </div>
          <div class="columns">
            <div class="column is-2"><h1 class="title is-6">Empresa</h1></div>
            <div class="column">
              <div class="buttons">
                <button
                  v-for="(item, index) in empresas.list"
                  :key="index"
                  class="button is-small"
                  :class="classEmpresa(item)"
                  @click="clicEmpresa(item)"
                >
                  {{ empresas[item].name }}
                </button>
                <button
                  class="button is-small"
                  :class="classEmpresa('todas')"
                  @click="clicEmpresa('todas')"
                >
                  Todas
                </button>
              </div>
            </div>
          </div>
        </section>
        <div class="columns">
          <div class="column">
            <div class="notification has-text-centered">
              <h1 class="title is-4">Pendientes</h1>
            </div>
            <div
              class="box hand"
              :style="stylebox(item.priority)"
              v-for="(item, index) in tasks.pendiente"
              :key="index"
              @click="selecticket(item)"
            >
              <div
                style="
                  position: absolute;
                  margin-top: -30px;
                  margin-left: -20px;
                  background-color: grey;
                  padding: 0 15px 0 5px;
                  border-radius: 5px 5px 2px 2px;
                "
              >
                <span class="has-text-white" style="font-size: 12px"
                  >{{ item.orden }} {{ item.project.name }}</span
                >
              </div>
              <h1 class="title is-6" :style="stylebox(item.priority)">
                {{ item.title }}
              </h1>
              <h2 class="subtitle is-7" :style="stylebox(item.priority)">
                {{ item.date | dateletra() }}
              </h2>
              <p style="font-size: 13px">{{ item.descripcion }}</p>
              <div>
                <div style="position: absolute; margin-top: -5px">
                  <span class="has-text-dark" style="font-size: 12px">{{
                    item.assignedto ? item.assignedto.displayName : ""
                  }}</span>
                </div>
              </div>
            </div>
          </div>
          <div class="column">
            <div class="notification has-text-centered">
              <h1 class="title is-4">En proceso</h1>
            </div>
            <div
              class="box hand"
              :style="stylebox(item.priority)"
              v-for="(item, index) in tasks.proceso"
              :key="index"
              @click="selecticket(item)"
            >
              <div
                style="
                  position: absolute;
                  margin-top: -30px;
                  margin-left: -20px;
                  background-color: grey;
                  padding: 0 15px 0 5px;
                  border-radius: 5px 5px 2px 2px;
                "
              >
                <span class="has-text-white" style="font-size: 12px"
                  >{{ item.orden }} {{ item.project.name }}</span
                >
              </div>
              <h1 class="title is-6" :style="stylebox(item.priority)">
                {{ item.title }}
              </h1>
              <h2 class="subtitle is-7" :style="stylebox(item.priority)">
                {{ item.date | dateletra() }}
              </h2>
              <p style="font-size: 13px">{{ item.descripcion }}</p>
              <div>
                <div style="position: absolute; margin-top: -5px">
                  <span class="has-text-dark" style="font-size: 12px">{{
                    item.assignedto ? item.assignedto.displayName : ""
                  }}</span>
                </div>
              </div>
            </div>
          </div>
          <div class="column">
            <div class="notification has-text-centered">
              <h1 class="title is-4">En Revisión</h1>
            </div>
            <div
              class="box hand"
              :style="stylebox(item.priority)"
              v-for="(item, index) in tasks.revision"
              :key="index"
              @click="selecticket(item)"
            >
              <div
                style="
                  position: absolute;
                  margin-top: -30px;
                  margin-left: -20px;
                  background-color: grey;
                  padding: 0 15px 0 5px;
                  border-radius: 5px 5px 2px 2px;
                "
              >
                <span class="has-text-white" style="font-size: 12px"
                  >{{ item.orden }} {{ item.project.name }}</span
                >
              </div>
              <h1 class="title is-6" :style="stylebox(item.priority)">
                {{ item.title }}
              </h1>
              <h2 class="subtitle is-7" :style="stylebox(item.priority)">
                {{ item.date | dateletra() }}
              </h2>
              <p style="font-size: 13px">{{ item.descripcion }}</p>
              <div>
                <div style="position: absolute; margin-top: -5px">
                  <span class="has-text-dark" style="font-size: 12px">{{
                    item.assignedto ? item.assignedto.displayName : ""
                  }}</span>
                </div>
              </div>
            </div>
          </div>
          <div class="column">
            <div class="notification has-text-centered">
              <h1 class="title is-4">Finalizado</h1>
            </div>
            <div
              class="box hand"
              :style="stylebox(item.priority)"
              v-for="(item, index) in tasks.resuelto"
              :key="index"
              @click="selecticket(item)"
            >
              <div
                style="
                  position: absolute;
                  margin-top: -30px;
                  margin-left: -20px;
                  background-color: grey;
                  padding: 0 15px 0 5px;
                  border-radius: 5px 5px 2px 2px;
                "
              >
                <span class="has-text-white" style="font-size: 12px"
                  >{{ item.orden }} {{ item.project.name }}</span
                >
              </div>
              <h1 class="title is-6" :style="stylebox(item.priority)">
                {{ item.title }}
              </h1>
              <h2 class="subtitle is-7" :style="stylebox(item.priority)">
                {{ item.date | dateletra() }}
              </h2>
              <p style="font-size: 13px">{{ item.descripcion }}</p>
              <div>
                <div style="position: absolute; margin-top: -5px">
                  <span class="has-text-dark" style="font-size: 12px">{{
                    item.assignedto ? item.assignedto.displayName : ""
                  }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <y-modalticket
      :showmodal="showmodal"
      :tags="todoslostags"
      :modaldata="task"
      :tickets="tickets"
      :status="statusselected"
      @closemodal="showmodal = false"
      @savemodal="savemodal"
      @deletetask="deleteTask"
    ></y-modalticket>
    <div class="modal" :class="{ 'is-active': showmodalproyect }">
      <div class="modal-background"></div>
      <div class="modal-card">
        <header class="modal-card-head">
          <p class="modal-card-title">Primero debe seleccionar el proyecto</p>
          <button
            class="delete"
            aria-label="close"
            @click="showmodalproyect = false"
          ></button>
        </header>
        <section class="modal-card-body">
          <div>
            <label class="label">Proyecto</label>
            <div class="control">
              <div class="select is-fullwidth">
                <select v-model="dataproject">
                  <option
                    v-for="(item5, index5) in projects"
                    :key="index5"
                    :value="item5"
                  >
                    {{ item5.empresaproject.name }} - {{ item5.name }}
                  </option>
                </select>
              </div>
            </div>
          </div>
        </section>
        <footer class="modal-card-foot">
          <button class="button is-success" @click="selectProject">
            Aceptar
          </button>
          <button class="button" @click="showmodalproyect = false">
            Cancelar
          </button>
        </footer>
      </div>
    </div>
  </div>
</template>

<script>
import yModalticket from "@/components/modals/Modalticket.vue";
import apiServices from "@/services/yungol-services";

export default {
  data() {
    return {
      statusselected: null,
      tickets: [],
      projects: [],
      dataproject: null,
      showmodalproyect: false,
      search: "",
      searchbytags: [""],
      todoslostags: ["error", "requerimiento"],
      incidencias: [],
      ticket: {},
      task: {
        orden: null,
        _id: null,
        date: null,
        title: null,
        descripcion: null,
        status: "Pendiente",
        tags: [],
        priority: "Baja",
        dateResolve: null,
        assignedto: null,
        ticket: null,
        empresa: null,
        project: null,
        horas: null,
        attach: [],
      },
      showmodal: false,
      tagsSelected: [],
      emrpesaSelected: [],
      empresas: {},
    };
  },
  computed: {
    tags() {
      var todoslostags = [];
      if (this.incidencias) {
        for (let index1 = 0; index1 < this.incidencias.length; index1++) {
          for (
            let index2 = 0;
            index2 < this.incidencias[index1].tags.length;
            index2++
          ) {
            var tag = this.incidencias[index1].tags[index2];

            if (!todoslostags.includes(tag)) {
              todoslostags.push(tag);
            }
          }
        }
      }
      return todoslostags;
    },
    tasks() {
      const _this = this;
      const returned = {
        pendiente: [],
        proceso: [],
        revision: [],
        resuelto: [],
      };
      let incidencias;
      if (this.tagsSelected.length > 0) {
        incidencias = this.incidencias.filter(function (item) {
          let control = false;
          for (let index in _this.tagsSelected) {
            if (item.tags.indexOf(_this.tagsSelected[index]) !== -1) {
              control = true;
            }
          }
          return control;
        });
      } else {
        incidencias = this.incidencias;
      }

      for (let index in incidencias) {
        const inc = this.incidencias[index];
        if (inc.status === "Pendiente") {
          returned.pendiente.push(inc);
        } else if (inc.status === "Proceso") {
          returned.proceso.push(inc);
        } else if (inc.status === "Revision") {
          returned.revision.push(inc);
        } else {
          returned.resuelto.push(inc);
        }
      }
      returned.pendiente.sort(function (a, b) {
        if (a.orden < b.orden) {
          return -1;
        }
        if (a.orden > b.orden) {
          return 1;
        }
        return 0;
      });
      return returned;
    },
  },
  methods: {
    classTag(tag) {
      if (this.tagsSelected.indexOf(tag) !== -1) {
        return "is-link";
      } else {
        return "";
      }
    },
    classEmpresa(emp) {
      if (this.emrpesaSelected.indexOf(emp) !== -1) {
        return "is-link";
      } else {
        return "";
      }
    },
    stylebox(prioridad) {
      if (prioridad === "Alta") {
        return "background-color:#feecf0; color: #cc0f35;";
      } else if (prioridad === "Media") {
        return "background-color: #fffaeb; color: #946c00;";
      } else {
        return "";
      }
    },
    async deleteTask(payload) {
      const result = await apiServices.delete(`/deletetask/${payload._id}`);
      if (result.data) {
        this.findTasks();
        this.showmodal = false;
        this.$store.dispatch("notify", {
          message: "Tarea borrada con éxito.",
          type: "is-primary",
          position: "top-center",
        });
      }
    },
    async savemodal(payload) {
      try {
        console.log("el payload, es ", payload);
        let result;
        if (payload._id) {
          result = await apiServices.post(`/edittask`, payload);
        } else {
          result = await apiServices.post(`/savetask`, payload);
        }
        if (result.data) {
          this.findTasks();
          this.showmodal = false;
          this.$store.dispatch("notify", {
            message: "Tarea guardada con éxito .",
            type: "is-primary",
            position: "top-center",
          });
        }
      } catch (err) {
        console.log(err);
      }
    },
    async findTasks() {
      try {
        const result = await apiServices.post(`/getalltasks`, {
          empresas: this.emrpesaSelected,
        });
        if (result.data) {
          this.incidencias = result.data;
        }
      } catch (err) {
        console.log(err);
      }
    },
    selectProject() {
      const d = {
        empresaproject: this.dataproject.empresaproject,
        project: {
          _id: this.dataproject._id,
          active: this.dataproject.active,
          created: this.dataproject.created,
          descripcion: this.dataproject.descripcion,
          name: this.dataproject.name,
          usermg: this.dataproject.usermg,
        },
      };
      this.showmodalproyect = false;
      this.newTask(d);
    },
    async findProjects() {
      try {
        const result = await apiServices.get(`/projectlistall`);
        if (result.data) {
          const empresas = { list: [] };
          this.projects = result.data;
          for (let index in result.data) {
            const proj = result.data[index];
            if (empresas.list.indexOf(proj.empresaproject._id) === -1) {
              empresas.list.push(proj.empresaproject._id);
              empresas[proj.empresaproject._id] = proj.empresaproject;
            }
          }
          this.empresas = empresas;
        }
      } catch (err) {
        console.log(err);
      }
    },
    showformProyect() {
      this.dataproject = null;
      this.showmodalproyect = true;
    },
    newTask(item) {
      this.task = {
        orden: null,
        _id: null,
        date: null,
        title: null,
        descripcion: null,
        status: "Pendiente",
        tags: [],
        priority: "Baja",
        dateResolve: null,
        assignedto: null,
        ticket: null,
        empresaproject: item.empresaproject,
        project: item.project,
        horas: null,
        attach: [],
      };
      this.showmodal = true;
    },
    selecticket(item) {
      item.horas = null;
      this.statusselected = JSON.parse(JSON.stringify(item.status));
      this.tickets = [];
      if (item.ticket) {
        item.ticket.empresa = item.empresa;
        const d = JSON.parse(JSON.stringify(item.ticket));
        const item1 = JSON.parse(JSON.stringify(item));
        d.empresa = item.empresa;
        this.tickets.push(d);
        item1.ticket = item.ticket._id;
        this.task = item1;
      } else {
        this.task = item;
      }
      if (item.assignedto) {
        const item2 = JSON.parse(JSON.stringify(this.task));
        item2.assignedto = this.task.assignedto._id;
        this.task = item2;
      }
      this.showmodal = true;
    },
    clicktag(tag) {
      if (this.tagsSelected.indexOf(tag) === -1) {
        this.tagsSelected.push(tag);
      } else {
        this.tagsSelected.splice(this.tagsSelected.indexOf(tag), 1);
      }
    },
    clicEmpresa(emp) {
      if (emp !== "todas") {
        if (this.emrpesaSelected.indexOf("todas") !== -1) {
          this.emrpesaSelected = [];
          this.emrpesaSelected.push(emp);
        } else if (this.emrpesaSelected.indexOf(emp) === -1) {
          this.emrpesaSelected.push(emp);
        } else {
          this.emrpesaSelected.splice(this.emrpesaSelected.indexOf(emp), 1);
        }
      } else {
        this.emrpesaSelected = ["todas"];
      }

      this.findTasks();
    },
  },
  created() {
    this.findProjects();
  },
  components: {
    yModalticket,
  },
};
</script>


// WEBPACK FOOTER //
// src/components/proyectos/task/Task.vue